/**
 * Reusable 3-way human review control — the single review action across layers.
 * Default = L1 accuracy (Accurate / Partially Accurate / Not Accurate). Other
 * layers pass their own `options` (same 3 slots, different labels):
 *   L2 relevance:    Material / Partially Material / Not Material
 *   L3 authority:    Allowed / Partly Allowed / Not Allowed
 *   L4 justification: Justified / Partly Justified / Not Justified
 */
export interface ReviewOption { key: string; label: string; color: string; mark: string }

export const ACCURACY_OPTIONS: ReviewOption[] = [
  { key: "accurate", label: "Accurate", color: "#5a8f6b", mark: "✓" },
  { key: "partial", label: "Partially Accurate", color: "#c9a23a", mark: "◐" },
  { key: "not_accurate", label: "Not Accurate", color: "#b3503f", mark: "✕" },
];

export default function ThreeWayReview({ value, onChange, options = ACCURACY_OPTIONS, disabled }: {
  value: string | null;
  onChange: (key: string) => void;
  options?: ReviewOption[];
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => {
        const active = value === o.key;
        return (
          <button key={o.key} type="button" disabled={disabled} onClick={() => onChange(o.key)}
            className="rounded border px-3 py-1.5 font-display text-sm font-light uppercase tracking-[0.1em] transition-colors disabled:opacity-50"
            style={active
              ? { background: o.color, color: "#0c0f12", borderColor: o.color }
              : { borderColor: `${o.color}55`, color: "#ECE5D8", background: "transparent" }}>
            {o.mark} {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function reviewColor(value: string | null, options: ReviewOption[] = ACCURACY_OPTIONS): string {
  return options.find((o) => o.key === value)?.color ?? "#5a6470";
}
